import { memo } from 'react'

const FCGeneralTermsPage = () => (
  <div>
    <title>General Terms and Conditions</title>
  </div>
)

export const GeneralTermsPage = memo(FCGeneralTermsPage)
